/*
 * @Descripttion: 配置数据
 * @version: 0.0.0
 * @Author: HeYang
 * @Date: 2020-01-06 16:33:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-14 15:26:47
 */
import { isWechat, isLjds, getParams } from '@/common/utils/tools'

// 灵机大师APP内嵌web平台标识
export const livePlatform = () => {
    const platform = localStorage.getItem('platform') || 16;
    return isLjds() ? platform : 16;
}

export const isOverseaPlatform = () => {
    const platform = getParams('platform') || localStorage.getItem('platform') || '';

    // 海外的平台号
    const overseaPlatform = ['36', '53', '54', '57'];
    return overseaPlatform.indexOf(platform) > -1;
};

// 是否简体
export const isZhCn = () => {
    // return !navigator.language || (navigator.language.toLocaleLowerCase() == 'zh-cn');
    const lowerLanguage = (navigator.language || '').toLowerCase();

    const isOversea = isOverseaPlatform();

    // 如果没有获取到language
    if (!lowerLanguage) return !isOversea;

    // 简体中文判断条件
    const hansSymbol = ['cn', 'hans', 'cmn'];

    // 繁体判断条件
    const hantSymbol = ['yue', 'hk', 'tw', 'hant'];

    const languageArr = lowerLanguage.split('-');
    const includesSymbol = (symbol: string) => languageArr.indexOf(symbol) > -1;

    const some = (arr: string[]) => {
        for (const key in arr) {
            const symbol = arr[key];
            if (includesSymbol(symbol)) {
                return true;
            }
        }

        return false;
    }

    if (isOversea) {
        // 遍历查找是否包含简体中文标识
        return some(hansSymbol);
    }

    // 遍历查找是否包含繁体中文标识
    return !some(hantSymbol);
}

// 灵机大师APP内嵌web支付渠道
const payConfig: any = () => {
    let payChannelObj = localStorage.getItem('payChannelObj') || '';
    if (payChannelObj) {
        return JSON.parse(payChannelObj);
    } else {
        return {
            H5_WECHAT_CHANNEL_ID: 1070,  // 浏览器微信支付
            ALIPAY_CHANNEL_ID: 7,  // 浏览器支付宝支付
            WECHAT_CHANNEL_ID: 480,  // 微信里面的微信支付
        }
    }
}
export const wechatPayChannelId = isWechat() ? payConfig().WECHAT_CHANNEL_ID : payConfig().H5_WECHAT_CHANNEL_ID;  // 微信支付
export const alipayChannelId = payConfig().ALIPAY_CHANNEL_ID;  // 支付宝支付

// 需要配置跳转到授权页的路由
export const authPath = ['/2020teacher', '/moreTeacher', '/voteIndex','/2020year','/2020year/order', '/newVip', '/qgindex', '/qgresult', '/voiceRec', '/chatHistory'];
// 已结束的活动路由
export const overPath = ['/2020teacher', '/moreTeacher', '/voteIndex','/2020year','/2020year/order', '/bag', '/bag148', '/mllLive', '/2020taohua', '/taohuaReward', '/2020valentine', '/timzhi666', '/2020anniversary'];
// 页面维护中的路由
export const protectPath = ['/allEquity', '/myVip', '/birthHistory', '/myEquity', '/equitySystem', '/vipEmail'];
